import request from '@/utils/request';
// import store from '@/store';

/**
 * 上传图片 - 修复token获取
 */
 export function uploadImage(file) {
  try {
    // 验证文件对象
    if (!file || !(file instanceof File)) {
      return Promise.reject(new Error('无效的文件对象'));
    }
    
    // 从localStorage获取token
    const token = localStorage.getItem('token') || '';
    
    if (!token) {
      return Promise.reject(new Error('用户未登录，请先登录'));
    }
    
    const formData = new FormData();
    // 确保参数名是"file"，与后端要求一致
    formData.append('file', file);
    
    console.log('上传文件信息:', {
      fileName: file.name,
      fileSize: file.size,
      parameterName: 'file', // 确认参数名
      contentType: file.type
    });
    
    return request({
      url: '/upload/image',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    });
  } catch (error) {
    console.error('上传图片准备失败:', error);
    return Promise.reject(new Error('上传准备失败: ' + error.message));
  }
}